import { createContext } from 'react'

export interface CookieContextState {
  cookies: Record<string, any>
  setCookie(key: string, value: any): void
}

export const CookieContext = createContext<CookieContextState | null>(null)
